export default "__VITE_ASSET__e0468ac6__"